import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import useTokenRefresh from "../hooks/useTokenRefresh";

/**
 * AuthGuard Component
 * Protects routes requiring authentication
 * Activates automatic token refresh
 */
const AuthGuard = ({ children }) => {
    const { isAuthenticated, user, accessToken } = useSelector((state) => state.auth);
    const location = useLocation();
    const dispatch = useDispatch();
    const hasLoggedOut = useRef(false);

    // Activate automatic token refresh
    useTokenRefresh();

    useEffect(() => {
        // If marked as authenticated but no user data or token, logout
        if (isAuthenticated && (!user || !accessToken) && !hasLoggedOut.current) {
            console.warn("Invalid authentication state detected. Logging out...");
            hasLoggedOut.current = true;
            dispatch({ type: 'LOGOUT' });
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
        }
    }, [isAuthenticated, user, accessToken, dispatch]);

    // Check for valid authentication
    if (!isAuthenticated || !user || !accessToken) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default AuthGuard; 